import { type MantineColorScheme } from '@mantine/core'
import Image from 'next/image'

import { ACCOUNT_LOGO_CONFIG } from './constants'
import { getAccountLogoSrc, getDatagroupLogo, hasAccountLogo } from './utils'

type AccountLogoProps = {
  account?: string
  datagroupId?: string
  colorScheme: MantineColorScheme
}

const AccountLogo = (props: AccountLogoProps) => {
  const { account, datagroupId, colorScheme } = props

  if (!hasAccountLogo(account)) {
    return null
  }

  const { logo, width, height } = getDatagroupLogo(account, datagroupId) ?? {
    logo: account,
    ...ACCOUNT_LOGO_CONFIG[account],
  }
  const src = getAccountLogoSrc(logo, colorScheme) ?? ''

  return <Image alt={account} height={height} src={src} title={account} width={width} />
}

export default AccountLogo
